module.exports = __webpack_public_path__ + "img/square-pen.afb860e8.svg";